import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from "@tellescope/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface SaveTemplateViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (name: string) => void;
  isSaving: boolean;
}

export const SaveTemplateViewDialog = ({ open, onOpenChange, onSave, isSaving }: SaveTemplateViewDialogProps) => {
  const { t } = useTranslation("templates");
  const [name, setName] = useState("");
  const [wasOpen, setWasOpen] = useState(open);
  if (open && !wasOpen) {
    setWasOpen(true);
    setName("");
  } else if (!open && wasOpen) {
    setWasOpen(false);
  }

  const trimmed = name.trim();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="templates-save-view-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t("Save as View")}</DialogTitle>
          <DialogDescription>{t("Save the current filters as a reusable view.")}</DialogDescription>
        </DialogHeader>
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            if (trimmed) onSave(trimmed);
          }}
        >
          <div className="space-y-1.5">
            <Label htmlFor="templates-view-name">{t("View name")}</Label>
            <Input
              id="templates-view-name"
              data-testid="templates-view-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("View name...")}
              autoFocus
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              {t("Cancel")}
            </Button>
            <Button type="submit" disabled={!trimmed || isSaving} data-testid="templates-save-view-confirm">
              {t("Save View")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
